import React, { useContext, useState, useEffect } from 'react';
import icon1 from '../../../Assets/Images/Home/icon1.png'
import icon2 from '../../../Assets/Images/Home/icon2.png'
import icon3 from '../../../Assets/Images/Home/icon3.png'
import FortificationsImg from '../../../Assets/Images/Fortifications.png'
import String from '../../../Assets/Localization/Local'
import { LangContext, userCookieContext, userSessionContext, } from '../../../App'
import { Link } from 'react-router-dom';
import './Services.css'
import ServiceModal from './ServiceModal'
import { Modal } from 'antd';
import cookie from 'react-cookies'
import { FormContext } from '../../../App'
import LoginForm from '../../Auth/Login/login'
import { Row, Col, Container } from 'react-bootstrap'

const Services = (props) => {
  let currentUser_cookie = cookie.load('HBUser');
  let currentUser_session = JSON.parse(sessionStorage.getItem("HBUser"));
  let user = currentUser_session ? currentUser_session : currentUser_cookie
  console.log('props...==> ', props,props.from )
  const { lang } = useContext(LangContext)
  const [showModal, setShowModal] = useState(false); // to show the prescription modal
  const [tempUser, setTempuser] = useState([]); // to show the prescription modal
  const [userExist, setUserExist] = useState(false);  // check if the user exist
  const { openForm, ToggleForm } = useContext(FormContext);  // to open login modal if user doesnot exist
  const [profileComplete, setProfileComplete] = useState(false);
  const [showProfileModal, setShowProfile] = useState(false);
  const { userCookie } = useContext(userCookieContext)
  const { userSession } = useContext(userSessionContext)
  console.log('profileCompleteprofileComplete-> ', profileComplete, userExist, userCookie, userSession)
  String.setLanguage(lang);

  let HBUser_cookie = cookie.load("HBUser");
  let HBUser_sessionStorage = JSON.stringify(sessionStorage.getItem("HBUser"));

  useEffect(() => {

    console.log("user take place ===>",HBUser_cookie,HBUser_sessionStorage,HBUser_sessionStorage !== "null" && HBUser_sessionStorage !== null)

    if (HBUser_cookie !== undefined) {
      setUserExist(true)
      if (HBUser_cookie.personalID.length === 0 || HBUser_cookie.phone === undefined || HBUser_cookie.email === undefined || HBUser_cookie.bloodType === undefined || HBUser_cookie.age === undefined || HBUser_cookie.nationalID === undefined) {
        setProfileComplete(false)
      }
      else {
        setProfileComplete(true)
      }
    }
    
    else if (HBUser_sessionStorage !== "null" && HBUser_sessionStorage !== null) {
      setUserExist(true)
      // setTempuser(HBUser_sessionStorage)
      let obj=JSON.parse(HBUser_sessionStorage)
      obj=JSON.parse(obj)
      console.log("user take place ===> sess",obj)
      if (obj.personalID.length === 0 || obj.phone === undefined || obj.email === undefined || obj.bloodType === undefined ||obj.age === undefined ||obj.nationalID === undefined) {
        setProfileComplete(false)
      }
      else {
        setProfileComplete(true)
      }
    }
    else {
      setUserExist(false)
    }
    console.log('hello !=> ', HBUser_cookie, HBUser_sessionStorage)

    if (props.userType === "currentUser") {
      if (HBUser_cookie !== undefined) {
        setTempuser(HBUser_cookie)
      } else if (HBUser_sessionStorage !== "null") {
        setTempuser(HBUser_sessionStorage)
      }
    } else {
      setTempuser(props.user)
    }
  }, [userCookie, userSession])

  const ToggleModal = () => {
    if (showModal === false) {
      setShowModal(true)
    } else {
      setShowModal(false)
    }
  }
  const ToggleCompelteProfileModal = () => {
    setShowProfile(!showProfileModal)
  }

  const renderCompleteProfileModeal = () => {
    return (
      <Modal
        title={null}
        visible={showProfileModal}
        footer={null}
        onCancel={ToggleCompelteProfileModal}
        centered
      >
        <Row className="m-0">
          <Col lg="12" className="styleIconn">
            {/* <i class="far fa-star-exclamation fa-5x" style={{color:'red'}}></i> */}
            <i class="fa fa-exclamation-circle fa-5x" style={{ color: 'red' }}></i>
          </Col>
          <Col lg="12" >
            <h3 className="text-center ">{String.ComleteProfile}</h3>
            <div className="d-flex">
              <Link to={{
                pathname: `/HealthBook-Web/edit-Profile`
              }}
                className="confrimProfileBtn"
              >{String.completemsg}</Link>
              <div className="skipbtn" onClick={ToggleCompelteProfileModal}>{String.skip}</div>
            </div>
          </Col>
        </Row>
      </Modal>
    )
  }
  console.log('prop=>services ', props)
  return (
    <div className="Services">
      <div className="container-fluid">
        <div className="row">
          <div className={(props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "col-lg-4 col-md-4 col-sm-12" : "col-lg-3 col-md-3 col-sm-12"}>
            <div className="servicecol">
              <div className="serviceimg">
                <img src={icon1} alt="serviceimg" />
              </div>
              <div onClick={() => {
                if (userExist === false) {
                  ToggleForm()
                }
                else {
                  // ToggleModal()

                  if (profileComplete === false) {
                    ToggleCompelteProfileModal()
                  }
                  else {
                    ToggleModal()
                  }
                }
              }} className="btn btn-block LinkStyle"
               style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.prescription}</div>
              {/* {props.from && props.from === "home" ?
                null
                : */}

                <Link to={{
                  pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/ViewPrescription" : '/HealthBook-Web/ShowAllServices',
                  // pathname: '/ViewPrescription',
                  state: { user: props.user ? props.user:user, userType: props.userType }
                }}
                  onClick={() => {
                    if (userExist === false) {
                      ToggleForm()
                    }
                    else if (profileComplete === false) {
                      ToggleCompelteProfileModal()
                    }
                  }}
                  className="btn btn-block EditLinkStyle"
                  style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }}  >
                  {String.Edit}
                </Link>
              {/* } */}
            </div>
          </div>
          <div className={(props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "col-lg-4 col-md-4 col-sm-12" : "col-lg-3 col-md-3 col-sm-12"}>
            <div className="servicecol">
              <div className="serviceimg">
                <img src={icon2} alt="serviceimg" />
              </div>

              <Link
                onClick={() => {
                  if (userExist === false) {
                    ToggleForm()
                  }
                  else if (userExist === true && profileComplete === false) {
                    ToggleCompelteProfileModal()
                  }
                }}
                to={{
                  pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/AddLab" : props.from && props.from === "home" ? "/HealthBook-Web/Home" : '/HealthBook-Web/ShowAllServices',
                  state: { user:  props.user ? props.user:user, userType: props.userType }
                }}
                className="btn btn-block LinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.lab}</Link>

              {/* {props.from && props.from === "home" ?
                null
                : */}
                <Link to={{
                  pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/viewLabs" : '/HealthBook-Web/ShowAllServices',
                  state: { user:  props.user ? props.user:user, userType: props.userType }
                }}
                  onClick={() => {
                    if (userExist === false) {
                      ToggleForm()
                    }
                    else if (profileComplete === false) {
                      ToggleCompelteProfileModal()
                    }
                  }}
                  className="btn btn-block EditLinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.Edit}</Link>
              {/* } */}
      
            </div>
          </div>
          <div className={(props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "col-lg-4 col-md-4 col-sm-12" : "col-lg-3 col-md-3 col-sm-12"}>
            <div className="servicecol">
              <div className="serviceimg">
                <img src={icon3} alt="serviceimg" />
              </div>
              {console.log('userExist==> ', userExist)}
              <Link to={{
                pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/AddRays" : props.from && props.from === "home" ? "/HealthBook-Web/Home" : '/HealthBook-Web/ShowAllServices',
                // pathname: userExist === true ? "/AddRays" : '/',
                state: { user:  props.user ? props.user:user, userType: props.userType }
              }}
                onClick={() => {
                  if (userExist === false) {
                    ToggleForm()
                  }
                  else if (profileComplete === false) {
                    ToggleCompelteProfileModal()
                  }
                }}
                className="btn btn-block LinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.rays}</Link>
              {/* {props.from && props.from === "home" ?
                null
                : */}
                <Link to={{
                  pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/ViewRays" : '/HealthBook-Web/ShowAllServices',
                  // pathname: userExist === true ? "/ViewRays" : '/',
                  state: { user:  props.user ? props.user:user, userType: props.userType }
                }}
                  onClick={() => {
                    if (userExist === false) {
                      ToggleForm()
                    }
                    else if (profileComplete === false) {
                      ToggleCompelteProfileModal()
                    }
                  }}
                  className="btn btn-block EditLinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.Edit}</Link>
              {/* } */}
            </div>
          </div>
          {props.userType !== 'currentUser' && props.user.type !== 'FAMILY' &&
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="servicecol">
                <div className="serviceimg">
                  <img src={FortificationsImg} alt="serviceimg" style={{ width: '100%', height: '100%' }} />
                </div>
                {console.log('userExist==> ', userExist)}
                <Link to={{
                  pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/AddFortifications" : props.from && props.from === "home" ? "/HealthBook-Web/Home" : '/HealthBook-Web/ShowAllServices',
                  // pathname: userExist === true ? "/AddFortifications" : '/',
                  state: { user:  props.user ? props.user:user, userType: props.userType }
                }}
                  onClick={() => {
                    if (userExist === false) {
                      ToggleForm()
                    }
                    else if (profileComplete === false) {
                      ToggleCompelteProfileModal()
                    }
                  }}
                  className="btn btn-block LinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.Fortifications}</Link>
                {/* {props.from && props.from === "home" ?
                  null
                  : */}
                  <Link to={{
                    pathname: userExist === true && profileComplete === true ? "/HealthBook-Web/ViewFortifications" : '/HealthBook-Web/ShowAllServices',
                    // pathname: userExist === true ? "/ViewFortifications" : '/',
                    state: { user:  props.user ? props.user:user, userType: props.userType }
                  }}
                    onClick={() => {
                      if (userExist === false) {
                        ToggleForm()
                      }
                      else if (profileComplete === false) {
                        ToggleCompelteProfileModal()
                      }
                    }}
                    className="btn btn-block EditLinkStyle" style={{ width: (props.userType === 'currentUser' || props.user.type === 'FAMILY') ? "40%" : "55%" }} >{String.Edit}</Link>
                {/* } */}
              </div>
            </div>
          }
        </div>
      </div>
      {console.log('showModal===> ')}
      {showModal === true && <ServiceModal user={tempUser} userType={props.userType} />}
      {showProfileModal === true && renderCompleteProfileModeal()}

    </div >
  );
}

export default Services;
